import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import InputBooleanBase, {
  INPUT_BOOLEAN_CHECKBOX,
  INPUT_BOOLEAN_VARIANTS,
  inputBooleanTypes
} from './InputBooleanBase';
import InputLabel from '../InputLabel';
import InputWrapper from '../InputWrapper';
import ValidationMessage from '../ValidationMessage';

const InputBoolean = ({
  checked,
  className,
  id,
  label,
  name,
  onBlur,
  onChange,
  value,
  validationState,
  variant,
  type,
  disabled,
  required,
  validationMessage,

  inputLabelProps,
  inputLabelWrapperProps,
  inputProps,
  inputWrapperProps,
  validationProps
}) => {
  const inputBooleanClass = [
    INPUT_BOOLEAN_VARIANTS.wide,
    INPUT_BOOLEAN_VARIANTS.fixed,
    INPUT_BOOLEAN_VARIANTS.flexible
  ].includes(variant);

  return (
    <InputWrapper
      {...inputWrapperProps}
      validationState={validationState}
      className={classnames(
        (inputBooleanClass || validationState) && 'input--boolean',
        variant === INPUT_BOOLEAN_VARIANTS.wide && 'input--wide-boolean',
        type === INPUT_BOOLEAN_CHECKBOX && 'input--square'
      )}
    >
      <div className={classnames('input__boolean-wrapper')}>
        <div
          {...inputLabelWrapperProps}
          className={classnames(
            className,
            (variant === INPUT_BOOLEAN_VARIANTS.regular ||
              variant === INPUT_BOOLEAN_VARIANTS.wide) &&
              'input__row'
          )}
        >
          <InputBooleanBase
            name={name}
            id={id || name}
            type={type}
            disabled={disabled}
            value={value}
            checked={checked}
            onChange={onChange}
            required={required}
            onBlur={onBlur}
            {...inputProps}
          />
          <InputLabel
            htmlFor={id || name}
            isRequired={required}
            {...inputLabelProps}
          >
            {label}
          </InputLabel>
        </div>
        <ValidationMessage
          validationState={validationState}
          {...validationProps}
        >
          {validationMessage}
        </ValidationMessage>
      </div>
    </InputWrapper>
  );
};

InputBoolean.defaultProps = {
  checked: false,
  variant: INPUT_BOOLEAN_VARIANTS.regular
};

InputBoolean.propTypes = {
  name: PropTypes.string,
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.node,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  type: PropTypes.oneOf(inputBooleanTypes),
  validationMessage: PropTypes.string,
  validationState: PropTypes.oneOf(['success', 'warning', 'error', undefined]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number
  ]),
  variant: PropTypes.oneOf(Object.keys(INPUT_BOOLEAN_VARIANTS)),

  inputLabelProps: PropTypes.object,
  inputLabelWrapperProps: PropTypes.object,
  inputProps: PropTypes.object,
  inputWrapperProps: PropTypes.object,
  validationProps: PropTypes.object
};

export default InputBoolean;
